import React from 'react';
var AutomationManualTriggersGlyph = function AutomationManualTriggersGlyph(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": label,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 5L10 19",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5L7 12H17L10 19",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default AutomationManualTriggersGlyph;